import React, { useState } from 'react'
import styled from 'styled-components'
import InputV2 from '../InputV2'

const TimePickerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const TimeSeparator = styled.span`
  color: #011533;
  font-size: 16px;
  font-weight: 400;
  margin: 0 2px;
`

const AMPMToggle = styled.div`
  display: flex;
  border: 1px solid #e2e2fc;
  border-radius: 6px;
  overflow: hidden;
  height: 32px;
`

const AMPMButton = styled.button`
  border: none;
  background: ${props => (props.active ? '#e2e2fc' : 'white')};
  color: ${props => (props.active ? '#011533' : '#707087')};
  font-weight: ${props => (props.active ? '700' : '400')};
  font-size: 14px;
  padding: 0 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${props => (props.active ? '#e2e2fc' : '#f5f5f5')};
  }
`

const TimePicker = ({ value = '07:00 AM', onChange = () => {} }) => {
  const [time, setTime] = useState(() => {
    const match = value.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i)
    if (match) {
      return {
        hours: parseInt(match[1], 10),
        minutes: parseInt(match[2], 10),
        period: match[3].toUpperCase(),
      }
    }
    return { hours: 7, minutes: 0, period: 'AM' }
  })

  const handleHoursChange = newHours => {
    const updatedTime = { ...time, hours: newHours }
    setTime(updatedTime)
    formatAndEmitTime(updatedTime)
  }

  const handleMinutesChange = newMinutes => {
    const updatedTime = { ...time, minutes: newMinutes }
    setTime(updatedTime)
    formatAndEmitTime(updatedTime)
  }

  const handlePeriodChange = newPeriod => {
    const updatedTime = { ...time, period: newPeriod }
    setTime(updatedTime)
    formatAndEmitTime(updatedTime)
  }

  const formatAndEmitTime = timeObj => {
    const formattedTime = `${timeObj.hours
      .toString()
      .padStart(2, '0')}:${timeObj.minutes.toString().padStart(2, '0')} ${
      timeObj.period
    }`
    onChange(formattedTime)
  }

  return (
    <TimePickerContainer>
      <InputV2
        value={time.hours}
        onChange={handleHoursChange}
        type="int"
        min={0}
        max={12}
        width="32px"
      />
      <TimeSeparator>:</TimeSeparator>
      <InputV2
        value={time.minutes.toString().padStart(2, '0')}
        onChange={handleMinutesChange}
        type="int"
        min={0}
        max={59}
        width="32px"
      />
      <AMPMToggle>
        <AMPMButton
          active={time.period === 'AM'}
          onClick={() => handlePeriodChange('AM')}
        >
          AM
        </AMPMButton>
        <AMPMButton
          active={time.period === 'PM'}
          onClick={() => handlePeriodChange('PM')}
        >
          PM
        </AMPMButton>
      </AMPMToggle>
    </TimePickerContainer>
  )
}

export default TimePicker
